<script lang="ts">
    import {dyData, modal} from 'general/store';
    import {TEMPLATE} from 'general/constants';
    import {fade} from 'svelte/transition';

    import GenderButton from 'general/components/genderButton/GenderButton.svelte';
    import Description from 'general/components/description/Description.svelte';
    import RoundCheckIcon from 'desktop/icons/RoundCheckLarge.svelte';
    import ShopConditions from './shopConditions/ShopConditions.svelte';

    import s from './style.module.css';
</script>

<div
    in:fade={{duration: 400}}
    class={s.main}
    style="margin-top: {$dyData.side.typ?.marginTop || 0}"
>
    <div class="iconContainer" class:iconSpace={$dyData.isSmallerScreen}>
        <div class="checkIcon" class:hideIcon={$dyData.isSmallerScreen}>
            <RoundCheckIcon size={68} color="#00995C" />
        </div>
    </div>

    <Description template={TEMPLATE.SQUARE_DESKTOP_COMMON} value={$dyData.description?.typ} />

    <ShopConditions />

    <div class={s.buttonContainer} class:buttonSmallScreen={$dyData.isSmallerScreen}>
        {#if $dyData.side.typ?.genderButton}
            <GenderButton />
        {:else}
            <button class={s.button} on:click={modal.close}> Continue Shopping </button>
        {/if}
    </div>
</div>
